import { render } from "./monture.vue?vue&type=template&id=00fb2d37&scoped=true"
import script from "./monture.vue?vue&type=script&lang=js"
export * from "./monture.vue?vue&type=script&lang=js"

import "./monture.vue?vue&type=style&index=0&id=00fb2d37&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fb2d37"]])

export default __exports__